import { Component, EventEmitter, inject, Output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  NavigationEnd,
  Router,
  RouterLink,
  RouterModule,
} from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { TablerIconComponent } from '@tabler/icons-angular';
import { AuthFacadeService } from '../../../../../domain/auth/service/auth-facade.service';
import { TranslateUtil } from '../../../../../shared/util/translate.util';
import { MenuItem } from '../../../../data/MenuItem';

@Component({
  selector: 'app-menu',
  imports: [RouterLink, TablerIconComponent, RouterModule, TranslatePipe],
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.scss',
})
export class MenuComponent {
  @Output() redirected = new EventEmitter<void>();

  private translateUtil = inject(TranslateUtil);

  public items: MenuItem[] = [
    {
      label: this.translateUtil.translate('NAVIGATION.MY_PATIENTS'),
      icon: 'users-group',
      routerLink: ['my-patients'],
    },
    {
      label: this.translateUtil.translate('NAVIGATION.MEETINGS'),
      icon: 'calendar',
      routerLink: ['meetings'],
    },
    {
      label: this.translateUtil.translate('NAVIGATION.REQUESTS'),
      icon: 'flag',
      routerLink: ['requests'],
    },
  ];

  constructor(
    private readonly router: Router,
    public readonly authFacadeService: AuthFacadeService
  ) {
    this.router.events.pipe(takeUntilDestroyed()).subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.redirected.emit();
      }
    });
  }

  public dt = {
    panel: {
      borderWidth: '0',
      padding: '0.25rem 0.25rem',
      first: {
        borderWidth: '0',
      },
      last: {
        borderWidth: '0',
      },
    },
  };
}
